import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import * as $ from 'jquery';

// Usuarios & Restablecer contraseña
import { UsuariosService } from '../services/usuarios.service';
// Usuarios & Restablecer contraseña

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit{
  // Variables para inicio de sesión
  public username: string;
  public password: string;
  public error: string;
  // Variables para Recuperar conraseña
  model:any={};

  title = 'Login';
  pageClass = 'login-page';

  constructor(public auth: AuthService, private router: Router,private usuarios: UsuariosService) { }
  /**
   * Se envia a validar los datos para el
   * inicio de sesion al servicio auth
   * @param username  Correo ingresado por el usuario.
   * @param password  Contraseña ingresada por el usuario.
  **/
  public submit() {
    this.auth.login(this.username, this.password)
      .pipe(first())
      .subscribe(
        result => this.router.navigate(['/']),
        err => this.error = 'Ocurrio un error al iniciar sesión.'
      );
  }
  

  public ngOnInit(){
    var materialInputs = $('input.input-material');

    // activate labels for prefilled values
    materialInputs.filter(function() { return $(this).val() !== ""; }).siblings('.label-material').addClass('active');

    // move label on focus
    materialInputs.on('focus', function () {
        $(this).siblings('.label-material').addClass('active');
    });

    // remove/keep label on blur
    materialInputs.on('blur', function () {
        $(this).siblings('.label-material').removeClass('active');

        if ($(this).val() !== '') {
            $(this).siblings('.label-material').addClass('active');
        } else {
            $(this).siblings('.label-material').removeClass('active');
        }
    });
  }
  /**
   * Mostrar el apartado para recuperar contraseña
   * @param error Se inicializa en vacio
   * @param correo Se inicializa correo a vacio
  **/
  divRecuperarPass(){
    this.error='';
    this.model={correo: ''};
    document.getElementById("entrar").style.display='none';
    document.getElementById("recuperar").style.display='block';
  }
  /**
   * Se valida el correo ingresado que sea valido.
   * @param errorCorreo Se inicializa en null y se reasigna a @param error
   * @param correo Ingresa el usuario
  **/
  enviarCorreo() {
    var errorCorreo=null;
    var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (this.model.correo.length==0) {
      errorCorreo='Campo Oblogatorio';
    } else if ( !emailRegex.test(this.model.correo) ) {
      errorCorreo='Ingresa un correo valido';
    }
    if (errorCorreo==null) {
      this.usuarios.generarToken(this.model.correo).subscribe(data=>{
        if (data!=null || data!='' || data.length!=0 || data!=[]) {
          if (data.error==0) {
            swal(data.message, {
              icon: "success",
            });
            this.router.navigate(['login']);
            this.divLoginPage();
          } else {
            swal({
              title: data.message,
              icon: "error",
              className: "swalOperador",
            });
          }
        }else{
          swal({
            title: 'Hubo un problema reintentarlo más tarde.',
            icon: "error",
            className: "swalOperador",
          });
        }
      });
    } else {
      this.error=errorCorreo;
    }
  }
  /**
   * Oculta apartado de recuperar contraseñ
   * @param error Se regresa a vacio
   * @param model Se regresa a vacio
  **/
  divLoginPage(){
    this.error='';
    this.model={};
    document.getElementById("recuperar").style.display='none';
    document.getElementById("entrar").style.display='block';
  }
}